import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";

import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";



const Bilingualism = () => {
  return (
    <>
      <PageHead title="Bilinguismo - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Bilinguismo" text="Bilinguismo" />
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <h4 className="title">Un Enfoque Integral para la Educación Bilingüe</h4>
              <p className="description mt--30 mb--15">
                El aprendizaje de un segundo idioma en la infancia tiene un impacto positivo en el desarrollo cognitivo y académico. Los niños bilingües suelen mostrar una mayor capacidad para resolver problemas, pensar de manera crítica y adaptarse a diferentes contextos. Además, el bilingüismo enriquece la comprensión cultural y promueve la empatía al permitir a los estudiantes experimentar y entender diversas perspectivas.
              </p>
              <p className="description mt--15 mb--30">
                Implementamos estrategias de enseñanza innovadoras y recursos didácticos de alta calidad para garantizar una experiencia de aprendizaje efectiva y placentera. Nuestros docentes nativos guían a los estudiantes en su viaje bilingüe, utilizando métodos interactivos y contextualizados que hacen del aprendizaje de un nuevo idioma una experiencia natural y enriquecedora. Nuestra pedagogía, basada en aprendizajes para la vida, se integra con un modelo cognitivo-lúdico y experiencial, que facilita la retención de conocimientos en la memoria física y mental, asegurando que los estudiantes puedan aplicarlos a lo largo de su crecimiento.
              </p>
              <div className="section-title text-start">
                <h4 className="title">¿Por qué queremos que tu hijo haga parte de nuestro proyecto de bilinguismo?</h4>
                <div className="rbt-feature-wrapper mt--40">
                  <div className="rbt-feature feature-style-1 align-items-center">
                    <div className="icon bg-primary-opacity">
                      <i className="feather-check-square"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">
                        Desarrollo Cognitivo Mejorado: El aprendizaje de un segundo idioma estimula el cerebro, mejorando la memoria, la concentración y la capacidad de multitarea.
                      </h6>
                    </div>
                  </div>
                  <div className="rbt-feature feature-style-1 align-items-center">
                    <div className="icon bg-secondary-opacity">
                      <i className="feather-check-square"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">
                        Mejora de Habilidades Académicas: Los estudiantes bilingües suelen tener ventajas en la lectura, la escritura y el pensamiento lógico, lo que se traduce en un rendimiento académico superior.
                      </h6>
                    </div>
                  </div>
                  <div className="rbt-feature feature-style-1 align-items-center">
                    <div className="icon bg-primary-opacity">
                      <i className="feather-check-square"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">
                      Preparación para el Futuro: En un mundo interconectado, ser bilingüe abre puertas a oportunidades profesionales y personales, proporcionando a los estudiantes una ventaja competitiva en el mercado laboral global.
                      </h6>
                    </div>
                  </div>
                  <div className="rbt-feature feature-style-1 align-items-center">
                    <div className="icon bg-secondary-opacity">
                      <i className="feather-check-square"></i>
                    </div>
                    <div className="feature-content">
                      <h6 className="feature-title">
                        Enriquecimiento Cultural: La exposición a diferentes idiomas y culturas fomenta una mayor apreciación y respeto por la diversidad, preparando a los estudiantes para ser ciudadanos globales responsables.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <h4 className="title mt--30">¿Sabes cómo lograremos nuestro objetivo de bilingüismo? Conoces el “Poder de 3”?</h4>
              <p className="description mt--30 mb--30">
                El "Poder de 3" es un marco curricular de lenguaje dual utilizado en el estado de Massachusetts en EEUU diseñado para  apoyar la educación bilingüe. Este programa se centra en tres áreas clave: 
              </p>
              <div className="rbt-feature feature-style-1 align-items-center">
                <div className="icon bg-primary-opacity">
                  <i className="feather-check-square"></i>
                </div>
                <div className="feature-content">
                  <h6 className="feature-title">
                    excelencia académica
                  </h6>
                </div>
              </div>
              <div className="rbt-feature feature-style-1 align-items-center">
                <div className="icon bg-secondary-opacity">
                  <i className="feather-check-square"></i>
                </div>
                <div className="feature-content">
                  <h6 className="feature-title">
                    bilingüismo y alfabetización bilingüe
                  </h6>
                </div>
              </div>
              <div className="rbt-feature feature-style-1 align-items-center">
                <div className="icon bg-primary-opacity">
                  <i className="feather-check-square"></i>
                </div>
                <div className="feature-content">
                  <h6 className="feature-title">
                   competencia sociocultural
                  </h6>
                </div>
              </div>
              <p className="description mt--30 mb--30">
              Su objetivo es que los estudiantes dominen tanto el inglés como otro idioma, al tiempo que desarrollan habilidades para interactuar en un mundo multicultural. El enfoque de Massachusetts con el "Poder de 3" demuestra su compromiso con una educación equitativa y de alta calidad para todos los estudiantes, preparando a los jóvenes para el éxito en una sociedad diversa
              </p>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Bilingualism;
